import './MeterBarTooltipItem.css';
export var valueContent = '_r5xi4l0-3-5-0';